const BACKEND_BASE = 'https://service.ig.com.br/carnaval_ig_delivery';

export const BACKEND_CARNIVAL_BASE = `${BACKEND_BASE}/events`;
export const BACKEND_CARNIVAL_FIND_ALL_EVENTS = `${BACKEND_CARNIVAL_BASE}`;
export const BACKEND_CARNIVAL_FIND_ALL_EVENTS_INFOS = `${BACKEND_CARNIVAL_BASE}/all`;
export const BACKEND_CARNIVAL_FIND_BY_CODE = `${BACKEND_CARNIVAL_BASE}/:id`;
